const Footer = () => {
	return (
		<footer aria-label="Impressum, Rechtliches" className="app--footer" role="contentinfo">
			<div>
				<div className="app--footer--legalline">
					<h2>© STANDARD Verlagsgesellschaft m.b.H. {new Date().getFullYear()}</h2>
					<p>
						Alle Rechte vorbehalten. Nutzung ausschließlich für den privaten Eigenbedarf.
						<br />
						Eine Weiterverwendung und Reproduktion über den persönlichen Gebrauch hinaus ist nicht
						gestattet.
					</p>
				</div>
				<nav aria-label="Weitere Angebote" className="app--footer--networknav">
					<h3 className="sr-only">Weitere Angebote</h3>
					<ul>
						<li>
							<a href="https://www.derstandard.de" rel="external" title="derStandard.de">
								derStandard.de
							</a>
						</li>
						<li>
							<a href="https://www.derstandard.at" rel="external" title="derStandard.at">
								derStandard.at
							</a>
						</li>
					</ul>
				</nav>
				<nav aria-label="Rechtliches" className="app--footer--legalnav">
					<h3 className="sr-only">Rechtliches</h3>
					<ul>
						<li>
							<a href="https://about.derstandard.at/impressum/" rel="external">
								Impressum &amp; Offenlegung
							</a>
						</li>
						<li>
							<a href="https://apps.derstandard.at/datenschutz" rel="external">
								Datenschutz
							</a>
						</li>
						<li>
							<a href="https://about.derstandard.at/agb/" rel="external">
								AGB
							</a>
						</li>
						<li>
							<a href="https://about.derstandard.at/" rel="external">
								Unternehmen
							</a>
						</li>
					</ul>
				</nav>
			</div>
			<a className="jumplabel" href="#top">
				Zum Seitenanfang
			</a>
		</footer>
	);
};

export { Footer };
